<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
      <div class="container">
        <a class="navbar-brand" href="#">Azure Dashboard</a>
  
        <div class="d-flex align-items-center">
          <!-- Show "Login with Microsoft" if user is NOT logged in -->
          <button v-if="!isLoggedIn" class="btn btn-outline-light btn-sm" @click="login">
            Login with Microsoft
          </button>
  
          <!-- Show User Info if Logged In -->
          <div v-else class="d-flex align-items-center">
            <span class="text-white me-2">{{ userName }}</span>
            <img :src="userPicture || defaultAvatar" class="rounded-circle user-avatar me-3" alt="User Avatar" />
            <button class="btn btn-outline-light btn-sm" @click="logout">Logout</button>
          </div>
        </div>
      </div>
    </nav>
  </template>
  
  <script>
  import { getUserProfilePicture } from '../utils/graphService';
  import { loginRequest } from '../authConfig';
  import { watchEffect, ref } from 'vue';
  
  export default {
    setup() {
      const userName = ref("");
      const userPicture = ref(null);
      const isLoggedIn = ref(false);
      const defaultAvatar = "https://www.gravatar.com/avatar/?d=mp";
  
      // Watch for MSAL account changes
      watchEffect(() => {
        const account = window.$msalInstance.getActiveAccount();
        if (account) {
          isLoggedIn.value = true;
          userName.value = account.name;
  
          getUserProfilePicture(window.$msalInstance, account.username)
            .then(picture => userPicture.value = picture)
            .catch(() => userPicture.value = defaultAvatar);
        } else {
          isLoggedIn.value = false;
          userName.value = "";
          userPicture.value = null;
        }
      });
  
      async function login() {
        try {
          await window.$msalInstance.loginRedirect(loginRequest);
        } catch (error) {
          console.error("Login error:", error);
        }
      }
  
      async function logout() {
        await window.$msalInstance.logoutRedirect();
        isLoggedIn.value = false;
      }
  
      return { userName, userPicture, isLoggedIn, login, logout, defaultAvatar };
    }
  };
  </script>
  
  <style scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border: 2px solid #fff;
  }
  </style>
  